import styled from 'styled-components';

export const FooterContainer = styled.div`
  width: 100%;
  padding: 1rem 0;
  display: flex;
  justify-content: center;
  //background: linear-gradient(100.26deg, rgba(0, 102, 255, 0.05) 42.33%, rgba(150, 0, 225, 0.05) 127.07%);
`;


export const FooterWrapper = styled.footer`
  width: 100%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  align-items: center;
  padding: 1rem;
  color: ${({ theme }) => theme.textPrimary};
`;

export const Logo = styled.h1`
  font-weight: 600;
  font-size: 20px;
  color: ${({ theme }) => theme.primary};
`;

export const BuiltBy = styled.h1`
  font-weight: 600;
  font-size: 20px;
  color: ${({ theme }) => theme.textPrimary};
`;

export const Copyright = styled.p`
  font-size: 0.9rem;
  color: ${({ theme }) => theme.soft2};
  text-align: center;
`;